import {Configuration, BackendApi} from "../generated-sources/openapi";

const configuration = new Configuration({
    basePath: process.env.NEXT_PUBLIC_BACKEND_HOST
})

export const BackendClient = new BackendApi(configuration);